import type { TypeRef, TypeRefFor } from "./index";


export type AsyncMethod<P extends any[] = any[], R = any> = (...args: P) => Promise<R>;


export type Method<P extends any[] = any[], R = any> = (...args: P) => R;


export type ParameterRef<P> = { [name: string]: TypeRefFor<P>; };


export type ParameterRefs<P extends any[]> =
    (void | {})[] extends P ? TypeRef[] :
    Required<P> extends [first: infer F, ...others: infer O] ? [ParameterRef<F>, ...ParameterRefs<O>] :
    [];
